import avatar from '../assets/images/kananda-ferreira/kananda-ferreira.jpg';
import audio from '../assets/sounds/kananda-ferreira.ogg';

import kananda01 from '../assets/images/kananda-ferreira/foto1.jpg';
import kananda03 from '../assets/images/kananda-ferreira/foto3.jpg';
import kananda04 from '../assets/images/kananda-ferreira/foto4.jpg';
import kananda05 from '../assets/images/kananda-ferreira/foto5.jpg';
import kananda06 from '../assets/images/kananda-ferreira/foto6.jpg';
import kananda07 from '../assets/images/kananda-ferreira/foto7.jpg';
import kananda08 from '../assets/images/kananda-ferreira/foto8.jpg';
import kananda09 from '../assets/images/kananda-ferreira/foto9.jpg';
import kananda10 from '../assets/images/kananda-ferreira/foto10.jpg';
import kananda11 from '../assets/images/kananda-ferreira/KanandaFerreira_01.jpg';
import kananda12 from '../assets/images/kananda-ferreira/KanandaFerreira_02.jpg';
import kananda13 from '../assets/images/kananda-ferreira/KanandaFerreira_03.jpg';
import kananda14 from '../assets/images/kananda-ferreira/KanandaFerreira_04.jpg';
import kananda15 from '../assets/images/kananda-ferreira/KanandaFerreira_05.jpg';
import kananda16 from '../assets/images/kananda-ferreira/KanandaFerreira_06.jpg';

const kanandaData = {
    avatar,
    audio,
    kananda01,
    kananda03,
    kananda04,
    kananda05,
    kananda06,
    kananda07,
    kananda08,
    kananda09,
    kananda10,
    kananda11,
    kananda12,
    kananda13,
    kananda14,
    kananda15,
    kananda16

}

export default kanandaData
